import { buildComponent } from '#components'
import Swiper from 'swiper'
import { Navigation, Scrollbar } from 'swiper/modules'

import './homepage-featured-cards.css'

const HomepageFeaturedCards = buildComponent({
  name: 'homepage-featured-cards',
  onConnected(component) {
    const cardsSliderEl = component.querySelector<HTMLElement>('[data-cards-slider]')

    if (!cardsSliderEl || cardsSliderEl.classList.contains('swiper-initialized')) return

    const nextEl = component.querySelector<HTMLElement>('.swiper-button-next')
    const prevEl = component.querySelector<HTMLElement>('.swiper-button-prev')
    const scrollbarEl = component.querySelector<HTMLElement>('.swiper-scrollbar')

    new Swiper(cardsSliderEl, {
      modules: [Navigation, Scrollbar],
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl,
        prevEl
      },
      scrollbar: {
        el: scrollbarEl,
        hide: false
      },
      breakpoints: {
        750: {
          slidesPerView: 2.5
        },
        990: {
          slidesPerView: 4
        }
      }
    })
  }
})

// Don't forget to declare the element tag name
// this is helpful for TypeScript to recognize the element`
declare global {
  interface HTMLElementTagNameMap {
    'homepage-featured-cards': typeof HomepageFeaturedCards
  }
}
